import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import ReactTable from "react-table";

import { makeStyles } from "@material-ui/core/styles";
import Assignment from "@material-ui/icons/Assignment";
import Delete from "@material-ui/icons/Delete";

import CustomInput from "components/CustomInput/CustomInput.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";

import { bookingApi } from "functions/apis";
import { token } from "functions/Helper";

const styles = {
  cardIconTitle: { ...cardTitle, marginTop: "15px", marginBottom: "0px" }
};
const useStyles = makeStyles(styles);

const CRITERIA = { 0: "Specific Date", 10: "Day Of Week", 20: "Daily" };
const DAYS = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday"
];

export default function QuotaPolicyList() {
  const source = useRef(new AbortController());
  const canWrite =
    token["booking.agent_quota_policies.write"] === "allowed" ||
    token.is_admin === "True";

  const [data, setData] = React.useState([]);
  const [pages, setPages] = React.useState(0);
  const [reload, setReload] = React.useState(0);
  const [pagination, setPagination] = React.useState({
    pageIndex: 1,
    pageSize: 10
  });
  const [filter, setFilter] = React.useState({ searchString: null });
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    return () => source.current.abort();
  }, []);

  const handleDelete = id => {
    if (!window.confirm("Delete this quota policy?")) return;
    bookingApi
      .delete("/AgentQuotaPolicies/" + id, { signal: source.current.signal })
      .then(() => setReload(r => r + 1))
      .catch(error => console.log(error));
  };

  useEffect(() => {
    setLoading(true);
    bookingApi
      .get("/AgentQuotaPolicies", {
        signal: source.current.signal,
        params: { filter, pagination }
      })
      .then(data => {
        setData(
          data.records.map(record => ({
            ...record,
            agentCode: record.agent?.code,
            routeCode: record.route?.code,
            departureTime: record.time,
            criteriaLabel:
              CRITERIA[record.criteriaType] +
              (record.criteriaType === 0 && record.date
                ? " (" + record.date.substring(0, 10) + ")"
                : record.criteriaType === 10 && record.dayOfWeek !== null
                ? " (" + DAYS[record.dayOfWeek] + ")"
                : ""),
            actions: canWrite && (
              <div className="actions-right">
                <Button
                  color="danger"
                  className="like"
                  onClick={() => handleDelete(record.id)}
                >
                  <Delete /> DELETE
                </Button>
              </div>
            )
          }))
        );
        setPages(Math.ceil(data.totalRecords / pagination.pageSize));
        setLoading(false);
      })
      .catch(error => console.log(error));
  }, [pagination, filter, reload]);

  const classes = useStyles();
  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="primary" icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>AGENT QUOTA POLICIES</h4>
          </CardHeader>
          <CardBody>
            {canWrite && (
              <Link to="/admin/AgentQuotaPolicies/Create">
                <Button color="rose">CREATE POLICY</Button>
              </Link>
            )}
            <GridItem xs={3}>
              <CustomInput
                labelText="Search"
                formControlProps={{ fullWidth: true }}
                inputProps={{
                  onChange: e =>
                    setFilter({
                      ...filter,
                      searchString:
                        e.target.value === "" ? null : e.target.value
                    }),
                  value: filter.searchString === null ? "" : filter.searchString
                }}
              />
            </GridItem>
            <ReactTable
              manual
              pages={pages}
              page={pagination.pageIndex - 1}
              pageSize={pagination.pageSize}
              onPageChange={page =>
                setPagination({ ...pagination, pageIndex: page + 1 })
              }
              onPageSizeChange={(pageSize, page) =>
                setPagination({ pageSize, pageIndex: page + 1 })
              }
              loading={loading}
              data={data}
              filterable={false}
              columns={[
                { Header: "Agent", accessor: "agentCode" },
                { Header: "Route", accessor: "routeCode" },
                { Header: "Time", accessor: "departureTime" },
                { Header: "Allocated", accessor: "allocatedSeat" },
                { Header: "Criteria", accessor: "criteriaLabel" },
                { Header: "Priority", accessor: "priority" },
                {
                  Header: "Actions",
                  accessor: "actions",
                  sortable: false,
                  filterable: false
                }
              ]}
              defaultPageSize={10}
              showPaginationTop
              showPaginationBottom={false}
              className="-striped -highlight"
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
